import React, { useState } from 'react';
import {
  useAppDispatch,
  useAppSelector,
} from 'store/hooks';
import { handleError } from 'utils/errorHandler';
import { logout } from 'store/user/userSlice';
// import userThunk from 'store/user/userThunk';
import ToggleButton from 'pages/Dashboard/components/ToggleButton';
import CrownIcon from 'components/CrownIconWrapper/CrownIconWrapper';
import Button from 'components/Button/Button';
import AuthContainer from 'components/AuthContainer';
import StyledSettings from './Settings.styles';
import GeneralSection from './components/GeneralSection/GeneralSection';
import PasswordSection from './components/PasswordSection/PasswordSection';

const buttonsArray = [
  {
    id: 1,
    title: 'General',
    section: <GeneralSection />,
  },
  {
    id: 2,
    title: 'Change Password',
    section: <PasswordSection />,
  },
];

const Settings: React.FC = () => {
  const [indexButtonPressed, setIndexButtonPressed] = useState<number>(0);
  const isLoading = useAppSelector((state) => state.userSlice.isLoading);
  const dispatch = useAppDispatch();
  const onClickLogout = async () => {
    try {
      // dispatch(userThunk.logout()).unwrap();
      dispatch(logout());
    } catch (error) {
      handleError(error, {});
    }
  };

  return (
    <AuthContainer>
      <StyledSettings>
        <h1>
          Settings
          <CrownIcon className="section__header-crown" />
        </h1>

        <div className="section__buttons-area">
          {buttonsArray.map((item, index) => (
            <ToggleButton
              key={index}
              isPressed={indexButtonPressed === index}
              title={item.title}
              onClick={() => setIndexButtonPressed(index)}
            />
          ))}
        </div>

        {buttonsArray[indexButtonPressed].section}

        <Button
          loading={isLoading}
          variant="contained"
          onClick={onClickLogout}
        >
          Logout
        </Button>
      </StyledSettings>
    </AuthContainer>
  );
};

export default Settings;
